import TKButtonDropdown from '@tk/controls/tk.button.dropdown';

export default class JUButtonDropDown extends TKButtonDropdown {
    show() {
        this.dialog?.show();
        this.button?.classList.add(this.selectedClassName);

        // diasable links, to prevent accidental link click on dialog open
        if (this.hasAttribute('data-prevent-accidental-link-click')) {
            const linkElements = this.dialog?.querySelectorAll('a');
            linkElements?.forEach((linkElement) => {
                linkElement.style.pointerEvents = 'none';
            });
        }

        setTimeout(() => {
            this.registerCloseListener();

            // reenable links
            if (this.hasAttribute('data-prevent-accidental-link-click')) {
                const linkElements = this.dialog?.querySelectorAll('a');
                linkElements?.forEach((linkElement) => {
                    linkElement.style.pointerEvents = '';
                });
            }
        });
    }
}
